/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class DrawingExportJobService {
        constructor(private $http: ng.IHttpService, private baseService: BaseService) { }

        public start(model: MainDrawingViewModel) {
            return this.baseService.post(`drawingexportjob/{companyNumber}/${model.associationNumber}/${model.departmentNumber}/${model.localizer}/start`, {}).then(j => { return j.data });
        }
    }

    DrawingExportJobService.$inject = ['$http', 'BaseService'];
    angular
        .module('eseebase')
        .service('DrawingExportJobService', DrawingExportJobService);
}